declare namespace $ {

	type $mol_link__uri_bog_bzrl_app_footer_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_bzrl_app_footer_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_footer_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_bzrl_app_footer_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_footer_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_footer_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_bzrl_app_footer_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_footer_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_bzrl_app_footer_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_footer_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_bzrl_app_footer_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_19 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_home_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_21 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_profile_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_23 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_all_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_25 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_rent_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_27 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_get_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_list__rows_bog_bzrl_app_footer_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_31 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_districts_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_33 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_new_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_35 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_furnished_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_37 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_pets_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_39 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_studio_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_list__rows_bog_bzrl_app_footer_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_43 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_privacy_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_45 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_terms_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_47 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_consent_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_bzrl_app_footer_49 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['nav_cookies_link'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_bzrl_app_footer_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_list__rows_bog_bzrl_app_footer_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_footer_54 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_footer['copyright'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_footer_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_bzrl_app_footer_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_footer extends $mol_view {
		Email( ): $mol_link
		Email_hint( ): $mol_paragraph
		Phone( ): $mol_link
		Phone_hint( ): $mol_paragraph
		Contact( ): $mol_view
		Ig_icon( ): $mol_image
		Ig( ): $mol_link
		Vk_icon( ): $mol_image
		Vk( ): $mol_link
		Tg_icon( ): $mol_image
		Tg( ): $mol_link
		Social( ): $mol_view
		Top( ): $mol_view
		nav_main_title( ): string
		nav_home_link( ): string
		nav_home( ): $mol_link
		nav_profile_link( ): string
		nav_profile( ): $mol_link
		nav_all_link( ): string
		nav_all( ): $mol_link
		nav_rent_link( ): string
		nav_rent( ): $mol_link
		nav_get_link( ): string
		nav_get( ): $mol_link
		Nav_main_links( ): $mol_list
		Nav_main( ): $mol_view
		nav_catalog_title( ): string
		nav_districts_link( ): string
		nav_districts( ): $mol_link
		nav_new_link( ): string
		nav_new( ): $mol_link
		nav_furnished_link( ): string
		nav_furnished( ): $mol_link
		nav_pets_link( ): string
		nav_pets( ): $mol_link
		nav_studio_link( ): string
		nav_studio( ): $mol_link
		Nav_catalog_links( ): $mol_list
		Nav_catalog( ): $mol_view
		nav_docs_title( ): string
		nav_privacy_link( ): string
		nav_privacy( ): $mol_link
		nav_terms_link( ): string
		nav_terms( ): $mol_link
		nav_consent_link( ): string
		nav_consent( ): $mol_link
		nav_cookies_link( ): string
		nav_cookies( ): $mol_link
		Nav_docs_links( ): $mol_list
		Nav_docs( ): $mol_view
		Nav( ): $mol_view
		copyright( ): string
		Copyright( ): $mol_paragraph
		Address( ): $mol_paragraph
		Bottom( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=footer.view.tree.d.ts.map